import { WarehouseLayoutSchema } from "@redotech/redo-model/wms/schema/warehouse";
import * as z from "zod";

export const listWarehouseLayouts = {
  name: "listWarehouseLayouts" as const,
  input: z.object({}),
  output: z.object({ layouts: z.array(WarehouseLayoutSchema) }),
};
